/* esm.sh - @radix-ui/react-compose-refs@1.1.2 */
export * from "/*@radix-ui/react-compose-refs@1.1.2/esnext/react-compose-refs.mjs";
